import { useQuery } from "@tanstack/react-query";
import { ProgramType } from "data/programData";
import { useRecoilValue } from "recoil";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";
import { patientAtom } from "../recoil/patientAtom";
import {
  retrospectApi,
  RETROSPECT_DOMAIN,
  RETROSPECT_LOAD_ENDPOINT,
} from "api/retrospectApi";

export default function useGetRetrospectData({
  weekNumber,
}: {
  weekNumber: number;
}) {
  const patient = useRecoilValue(patientAtom);

  const queryKey = [
    RETROSPECT_DOMAIN,
    RETROSPECT_LOAD_ENDPOINT,
    patient?.patientId,
    weekNumber,
  ] as const;

  const { data } = useQuery(queryKey, () =>
    retrospectApi.load(weekNumber, patient?.patientId as number),
    {
      enabled: !!patient?.patientId && Number.isFinite(weekNumber),
      refetchOnWindowFocus: false,
      select: (resp): ProgramType | undefined => {
        const totalData = resp?.result?.data;
        if (totalData && totalData.content && totalData.content.length > 0) {
          return setDataWithEditorKeyAndTranslationVersion(totalData);
        }
        return undefined;
      },
    }
  );

  return { data };
}
